import { Dialog, DialogActions, DialogContent, Grid } from '@material-ui/core';
import React from 'react'
import AppBarModal from '../../general/AppBarModal';
import TareasTerminadas from '../../general/TareasTerminadas';
import { BtnForm } from '../../general/BotonesAccion';
import InputBuscar from '../../general/InputBuscar';
import BuscarPersona from '../../general/BuscarPersona';
import { consulta } from '../../../global/js/funciones';

const ModalEditarCoordinador = ({ modalEditarCoordinador, mostrarModalEditarCoordinador, actualizarMensaje, validacion, actualizarDataValidaciones }) => {

    const [cargando, setCargando] = React.useState(false);
    const [buscarCoordinador, setBuscarCoordinador] = React.useState(false);    
    const [coordinador, setCoordinador] = React.useState(validacion?.coordinador ?? null);
    const [validacionActual, setValidacionActual] = React.useState({});
    
    React.useEffect(() => {
        setCoordinador(validacion?.coordinador ?? null);
        setValidacionActual(validacion ?? {});
    }, [validacion?.id]);

    const handleGuardar = () => {
        setCargando(true);
        consulta(`api/v1.0/validaciones/actualizar_coordinador/${validacionActual.id}`, { coordinador: coordinador.id }, 'PUT', (error, estado, resp) => {
            if (estado === 200) {
                actualizarDataValidaciones();
                actualizarMensaje({ titulo: 'Coordinador actualizado', tipo: 'success', mostrar: true, tiempo: 6000 });
                mostrarModalEditarCoordinador(false);
            } else if (estado === 302) actualizarMensaje({ titulo: resp.titulo, tipo: 'warning', mostrar: true, tiempo: 6000 });
            else actualizarMensaje({ titulo: 'Error al actualizar el coordinador', tipo: 'error', mostrar: true, tiempo: 6000 });
        });
        setCargando(false);
    }

    return (
        <>
            <Dialog open={modalEditarCoordinador} maxWidth="xs" fullWidth={true} onClose={() => mostrarModalEditarCoordinador(false)}>
                <AppBarModal titulo='¡ Editar Coordinador !' mostrarModal={mostrarModalEditarCoordinador} titulo_accion='' />
                <DialogContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }} className='scroll' >
                    {
                        cargando ?
                            <TareasTerminadas mensaje='Cargando...' marginTop='5%' />
                            :
                            <Grid item xs={12} md={12}>
                                <InputBuscar
                                    placeholder='Seleccione Profesor'
                                    label={'Profesor'}
                                    id='coordinador'
                                    value={`${coordinador?.primer_nombre ?? ''} ${coordinador?.primer_apellido ?? ''} ${coordinador?.segundo_apellido ?? ''}`}
                                    callback={() => setBuscarCoordinador(true)} />
                            </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="Guardar" callback={() => handleGuardar()} />
                    <BtnForm texto="Cerrar" callback={() => mostrarModalEditarCoordinador(false)} />
                </DialogActions>
            </Dialog>

            <Dialog fullWidth={true} maxWidth="sm" open={buscarCoordinador} onClose={() => setBuscarCoordinador(false)}>
                <AppBarModal titulo={'¡ Buscar Coordiandor !'} mostrarModal={() => setBuscarCoordinador(false)} titulo_accion="CERRAR" accion={() => setBuscarCoordinador(false)} />
                <DialogContent style={{ padding: '0' }} className='scroll'>

                    <BuscarPersona callback={({ id, primer_nombre, primer_apellido, segundo_apellido }) => {
                        setCoordinador({ id, primer_nombre, primer_apellido, segundo_apellido });
                        setBuscarCoordinador(false);
                    }} />

                </DialogContent>
                <DialogActions>
                    <BtnForm texto="CANCELAR" callback={() => setBuscarCoordinador(false)} />
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModalEditarCoordinador